<template>
  <div>
    <!-- 配送单-配送标规格选择 -->
    <el-dialog :title="$t('message.shippingLabelSpec')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="320px" center>
      <div class="content">
        <el-select v-model="page_type" placeholder="请选择配送标规格">
          <el-option label="Letter_6张" value="PackageLabel_Letter_6"></el-option>
          <el-option label="热转印_1张" value="PackageLabel_Thermal"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 下载 -->
        <el-button type="primary" @click="save">{{
          $t("message.download")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    porder_sn: { type: String },
  },
  data() {
    return {
      page_type: 'PackageLabel_Letter_6',
      dialogVisible: false
    };
  },
  created() {

  },
  methods: {
    // 保存
    save() {
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = this.baseURL + `/amazon.downBoxLabel?porder_sn=${this.porder_sn}&page_type=${this.page_type}`;
      a.click();
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 30px;
}
</style>